import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { Context } from 'bernie-context';
import { AbacusControl, AbacusExperiment, AbacusVariant } from 'bernie-abacus';
import { formatText } from 'bernie-l10n';
import { ShortlistStore } from '../../stores';
import { SecondaryButtonTracked, FavoriteSwitchTracked, TertiaryButtonTracked } from '../../utils/click-trackers';

export interface FavoriteButtonProps {
  isButton?: boolean;
  activityId?: string;
  activityName?: string;
  className?: string;
  shortlistStore?: ShortlistStore;
  context?: Context;
  page: string;
  id?: string;
  activityGroup?: string;
}

@inject('context')
@observer
export class FavoriteButton extends React.Component<FavoriteButtonProps> {
  private inputRef: React.RefObject<HTMLElement>;

  constructor(props: FavoriteButtonProps) {
    super(props);
    this.inputRef = React.createRef();
  }

  private isSaved = (): boolean => {
    const { shortlistStore, activityId } = this.props;

    if (!shortlistStore) {
      return false;
    }

    return (
      shortlistStore.shortlistedActivityIds !== undefined &&
      shortlistStore.shortlistedActivityIds.some(it => it === activityId)
    );
  };

  private saveToggle = (): void => {
    const { shortlistStore, activityId, activityName } = this.props;
    const isSaved = this.isSaved();

    if (!shortlistStore || !activityId || !activityName) {
      return;
    }

    if (isSaved) {
      shortlistStore.removeShortlisted(activityId);
    } else {
      shortlistStore.addShortlisted(activityId);
      shortlistStore.updateAndShowNotification(activityName);
    }
  };

  public render(): JSX.Element {
    const { isButton, activityId, activityName, page, className, activityGroup } = this.props;

    const isSaved = this.isSaved();

    const favoriteSwitchId = activityGroup
      ? `favoriteActivity${activityId}-${activityGroup}`
      : `favoriteActivity${activityId}`;

    const favoriteSwitchLabel = isSaved
      ? formatText('lx.activity.favoriting.button.label.unsave', activityName)
      : formatText('lx.activity.favoriting.button.label.save', activityName);
    const rfrr = isSaved ? `Shortlist.Save.Unsave.LX.LX-${page}` : `Shortlist.Save.Save.LX.LX-${page}`;

    const favoriteButton = (): JSX.Element => (
      <div data-testid="heart-button--button" className={className}>
        <AbacusExperiment name="LX_PWA_IS_TOP_SECTION_RESTRUCTURE">
          <AbacusControl>
            <SecondaryButtonTracked
              onClick={this.saveToggle}
              rfrr={rfrr}
              linkName={rfrr}
              text={formatText('lx.activity.label.save')}
              icon={isSaved ? 'favorite' : 'favorite_border'}
              aria-label={favoriteSwitchLabel}
            />
          </AbacusControl>
          <AbacusVariant bucket={1}>
            <TertiaryButtonTracked
              onClick={this.saveToggle}
              text={formatText('lx.activity.label.save')}
              icon={isSaved ? 'favorite' : 'favorite_border'}
              aria-label={favoriteSwitchLabel}
              rfrr={rfrr}
              linkName={rfrr}
            />
          </AbacusVariant>
        </AbacusExperiment>
      </div>
    );

    const favoriteSwitch = (): JSX.Element => (
      <div data-testid="heart-button-switch" className={className}>
        <FavoriteSwitchTracked
          checked={isSaved}
          id={favoriteSwitchId}
          label={favoriteSwitchLabel}
          onChange={this.saveToggle}
          ref={this.inputRef}
          rfrr={rfrr}
          linkName="RFRR Action Link"
        />
      </div>
    );

    return <>{isButton ? favoriteButton() : favoriteSwitch()}</>;
  }
}
